export class ProjectModuleStatic{

    static CurrentProjectModuleId: number;

}


// WEBPACK FOOTER //
// ./src/app/domain/project-module.static.ts